import React from 'react';

export const Agendas = React.lazy(() => import('./Agendas/Agendas'));
export const Inbox = React.lazy(() => import('./Inbox/Inbox'));
export const Monitors = React.lazy(() => import('./Monitors/Monitors'));
export const Monitor = React.lazy(() => import('./Monitors/Monitor'));
export const PreparePackage = React.lazy(
  () => import('./PreparePackage/PreparePackage')
);
